module.exports = __webpack_public_path__ + "static/media/carton.7c78ab5e.png";